import { Link } from "react-router-dom";
import { GAME_PAGES } from "@/lib/constants";

export const GameLogos = ({ testid = "game-logos" }) => (
  <div className="grid grid-cols-2 gap-3 sm:grid-cols-4 lg:grid-cols-7" data-testid={testid}>
    {GAME_PAGES.map((g, i) => (
      <Link key={g.slug} to={`/gioco/${g.slug}`} data-testid={`${testid}-${g.slug}`} title={g.title}
        className="sticker-btn fade-up group flex h-24 items-center last:col-span-2 sm:last:col-span-1 justify-center rounded-2xl bg-black p-3" style={{ animationDelay: `${i * 50}ms` }}>
        <img src={g.logo} alt={g.title} className="max-h-full max-w-full object-contain transition-transform duration-300 group-hover:scale-110" />
      </Link>
    ))}
  </div>
);
